import { IOpenPanel } from "../../../../../Interfaces/IPanel"
import { PanelFooter } from "../../../../../components/Panel/PanelFooter"
import { IComboBoxOption, Panel, PanelType } from "@fluentui/react"
import { ComboBoxComponent } from "../../../../../components/comboBox/ComboBoxComponent"
import { UseComboRazon } from "../../../../../hooks/auxiliar/combo/UseComboRazon"
import { PanelHeader } from "../../../../../components/Panel/PanelHeader"
import { IFilter2, IT, keyType, textType } from "../useDetalleEquipo"
import { useComboEstadoEquipo } from "../../../../../hooks/auxiliar/combo/useComboEstadoEquipo"
import { UseComboUbicacion } from "../../../../../hooks/auxiliar/combo/UseComboUbicacion"
import { useOperador } from "../../../../../hooks/auxiliar/combo/UseOperadores"

export interface IPanelFiltroDetalleEquipo extends IOpenPanel {
  reload: () => void
  equipoId?: string,
  isOpen: boolean;
  resetFilter2: () => void;
  buscar: () => void;
  onDismiss: () => void;
  filter2: IFilter2
  onChangeComboFilter?: (data: IT) => void
}
interface IR {
  data?: IComboBoxOption,
  key: keyType,
  text: textType
}
export const PanelFiltroDetalleEquipo = ({
  isOpen,
  resetFilter2,
  onChangeComboFilter,
  filter2,
  buscar,
  onDismiss,
  equipoId

}) => {

  const { dataComboRazon, setFilter, filter } = UseComboRazon(isOpen);
  const { dataComboEstado, setfilterEstado, filterEstado } = useComboEstadoEquipo(isOpen)
  const { dataComboUbicacion, filterCombo, setFilterCombo } = UseComboUbicacion({ comboNivel: 3, isOpen: isOpen })
  const { dataComboOperadores, filterOperador, setFilterOperador } = useOperador({ isOpen, equipoId: equipoId })

  const handleOnChange = ({ data, key, text }: IR) => {
    if (data) {
      onChangeComboFilter({
        key,
        keyValue: `${data.key}`,
        text,
        textValue: data.text
      })
    }
  };

  return (
    <Panel
      type={PanelType.smallFixedFar}
      isOpen={isOpen}
      // onDismiss={cerrarPanel}
      onRenderHeader={() =>
        <PanelHeader
          textHeader="Detalle Histórico"
          subTextHeader={`Búsqueda Avanzada`}
        />
      }
      onRenderFooter={() =>
        <PanelFooter
          texto="Buscar"
          texto2={"Limpiar"}
          onClick={buscar}
          disableButton={false}
          onDismiss={resetFilter2}
        />
      }
      isFooterAtBottom
      onDismiss={onDismiss}
    >
      <ComboBoxComponent
        text={"Ubicaciones"}
        selectedKey={filter2.ubicacionId}
        placeholder="Seleccione Ubicación"
        data={dataComboUbicacion}
        onChange={(value) => {
          setFilterCombo({
            ...filterCombo,
            search: value
          })
        }}
        onOptionSelect={(event, option) => {
          handleOnChange({
            data: option, key: 'ubicacionKey', text: 'ubicacionText'
          })
        }}
        defaultSelectedOptions={[{
          key: filter2.ubicacionKey,
          text: filter2.ubicacionText
        }]}
      />
      <ComboBoxComponent
        text={"Estado"}
        selectedKey={filter2.estadoId}
        placeholder="Seleccione Estado"
        data={dataComboEstado}
        onChange={(value) => {
          setfilterEstado({
            ...filterEstado,
            search: value
          })
        }}
        onOptionSelect={(event, option) => {
          handleOnChange({
            data: option, key: 'estadoKey', text: 'estadoText'
          })
        }}
        defaultSelectedOptions={[{
          key: filter2.estadoKey,
          text: filter2.estadoText
        }]}
      />
      <ComboBoxComponent
        text={"Razón"}
        selectedKey={filter2.razonId}
        placeholder="Seleccione Razón"
        data={dataComboRazon}
        onChange={(value) => {
          setFilter({
            ...filter,
            search: value
          })
        }}
        onOptionSelect={(event, option) => {
          handleOnChange({ data: option, key: 'razonKey', text: 'razonText' })
        }}
        defaultSelectedOptions={[{
          key: filter2.razonKey,
          text: filter2.razonText
        }]}
      />
      <ComboBoxComponent
        text={"Operadores"}
        selectedKey={filter2.operadorId}
        placeholder="Seleccione Operador"
        data={dataComboOperadores}
        onChange={(value) => {
          setFilterOperador({
            ...filterOperador,
            search: value,
            equipoId: equipoId
          })
        }}
        onOptionSelect={(event, option) => {
          handleOnChange({
            data: option, key: 'operadorKey', text: 'operadorText'
          })
        }}
        defaultSelectedOptions={[{
          key: filter2.operadorKey,
          text: filter2.operadorText
        }]}
      />
    </Panel>)
}